<template>
  <v-container>
    <v-card>
      <v-card-title>Reprocesar imputación de cobranzas</v-card-title>
      <v-card-subtitle>Este job recorre todas las cobranzas y regenera las imputaciones correspondientes en cada deuda</v-card-subtitle>

      <v-card-text class="text-center">
        <v-btn color="primary OnPrimary--text" @click="generar">Generar</v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import JobProvider from "@/modules/cobrox/providers/JobProvider";

export default {
  name: "ReprocesarImputacionCobranzasPage",
  data(){
    return {
      jobId: null
    }
  },
  methods: {
    generar() {
      JobProvider.reprocesarImputacionCobranzas()
          .then(r => {
            this.jobId = r.data.reprocesarImputacionCobranzas
            this.$router.push({name: "JobPage", params: {id: this.jobId}})
          })
    }
  }
}
</script>

<style scoped>

</style>
